import { useCallback } from 'react';

export function useRipple() {
  const triggerRipple = useCallback((e) => {
    const el = e.currentTarget;
    el.classList.remove('ripple-active');
    void el.offsetWidth;
    el.classList.add('ripple-active');
    setTimeout(() => el.classList.remove('ripple-active'), 500);
  }, []);

  return triggerRipple;
}